import React, { useEffect, useState } from 'react';

const Psn = () => {
    const [games, setGames] = useState([]);

    useEffect(() => {
        fetch(`/.netlify/functions/psn-games`) // ton endpoint backend
        .then((res) => res.json())
        .then((data) => setGames(data));
    }, []);

    useEffect(() => {
        console.log(games);
    }, [games]);

    return (
        <div>
            <span>Michel alabama</span>
             <ul>
                <li>dd</li>>
            </ul>
        </div>
    )
};

export default Psn;